import React from 'react';
import { ActionButton } from '@manulife/mux';
import { Reload } from '@manulife/mux-cds-icons';
import { useTranslation } from './translationContext';
import { im } from 'mathjs';

const TableFilterResetButton = ({ handleClick }) => {
  const { t } = useTranslation();
  return (
    <ActionButton
      id={'reset-button'}
      className="reset-search mt-2"
      aria-label={t('tablefilter.reset')}
      onClick={handleClick}
      icon={<Reload />}>
      {t('tablefilter.reset')}
    </ActionButton>
  );
};

export default TableFilterResetButton;
